import { Layout, Page } from "@fdoh/health-ui-react";
import { useRef } from "react";
import {useHistory,  useLocation } from "react-router-dom";
import DrainfieldInstallationInspectionForm from "../Components/DrainFieldInstallationInspectionForm";
import { DrainFieldInstallationInspectionInput } from "../Components/DrainFieldInstallationInspectionForm.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";


// TODO: Add error handling

const CreateDrainfieldInstallationPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

  return applicationId ?   (
    <Page.Container>
      <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <DrainfieldInstallationInspectionForm
            id="createDrainfieldInstallationInspectionForm"
            title="Drainfield Installation Inspection"
            action="post"
                      applicationId={applicationId ? applicationId : 0}
                      applicationInspectionId={inspectionId ? inspectionId : 0}
                      returnPath={`/inspectionDetails/${inspectionId}`}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>
    
  </div>;
};

export default CreateDrainfieldInstallationPage;